import { Skeleton, Stack, useTheme } from "@mui/material";
import { useMemo } from "react";
import { createId } from "web_myplann/Shared/Utils/createId";

type DashboardSkeletonProps = {
	height?: number;
	count?: number;
};

const SkeletonItem = ({ height }: { height: number }) => {
	const theme = useTheme();

	return (
		<Skeleton
			variant="rounded"
			height={height}
			sx={{ borderRadius: theme.radii.lg }}
			animation="wave"
		/>
	);
};

export const DashboardSkeleton = ({
	height = 150,
	count = 1,
}: DashboardSkeletonProps) => {
	const keys = useMemo(
		() => Array.from({ length: count }, () => createId()),
		[count],
	);

	return (
		<Stack gap={1.2}>
			{keys.map((key) => (
				<SkeletonItem key={key} height={height} />
			))}
		</Stack>
	);
};
